import arLang from './locales/ar_SA';
import deLang from './locales/de_DE';
import enLang from './locales/en_US';
import esLang from './locales/es_ES';
import frLang from './locales/fr_FR';
import heLang from './locales/he_HE';
import huLang from './locales/hu_HU';
import itLang from './locales/it_IT';
import jaLang from './locales/ja_JA';
import koLang from './locales/ko_KO';
import ruLang from './locales/ru_RU';
import zhLang from './locales/zh_Hans';

const AppLocale = {
    en: enLang,
    fr: frLang,
    zh: zhLang,
    ar: arLang,
    he: heLang,
    de: deLang,
    ru: ruLang,
    es: esLang,
    ja: jaLang,
    ko: koLang,
    it: itLang,
    hu: huLang,
};

export default AppLocale;
